import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-bs5';
import { WkoLoadingSpinner } from '../WkoLoadingSpinner';
import { notifyError } from '../../utils/notifications';
import { BenchmarkCard } from './BenchmarkCard';
DataTable.use(DT);
const columns = [
    { data: 'Name', orderable: false },
    { data: 'UserFleetNcDaysPerVisit', className: 'text-end' },
    { data: 'IndustryNcDaysPerVisit', className: 'text-end' },
];
const OTHER_ACTIVITY_MESSAGE = 'Location stats not available for "Other" activities. Please choose a different activity to view detailed analysis by location.';
export function ActivityLocation({ options, title = 'Non-conformities by location in the selected period', }) {
    const [data, setData] = useState([]);
    useEffect(() => {
        if (!options.isReady)
            return;
        setData([]);
        if (options.activityType?.startsWith('Other (')) {
            setData([
                {
                    Name: OTHER_ACTIVITY_MESSAGE,
                    UserFleetNcDaysPerVisit: null,
                    IndustryNcDaysPerVisit: null,
                },
            ]);
            return;
        }
        const params = new URLSearchParams({
            activity: options.activityType || '',
            fromMonth: options.startDate.substring(0, 7),
            toMonth: options.endDate.substring(0, 7),
            fleets: options.fleet.map((f) => f.ID).join(','),
            vesselTypes: options.vesselTypes.join(','),
        });
        fetch(`/api/benchmark/activitytopnclocations?${params}`)
            .then((res) => {
            if (res.ok)
                return res.json();
            throw new Error(res.statusText);
        })
            .then((stats) => setData(stats))
            .catch(() => notifyError('An error occurred when loading location stats. Please try again.'));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        options.isReady,
        options.activityType,
        options.startDate,
        options.endDate,
        options.fleet.map((f) => f.ID).join(','),
        options.vesselTypes.join(','),
    ]);
    if (!options.isReady) {
        return (_jsx(BenchmarkCard, { title: title, children: _jsx(WkoLoadingSpinner, {}) }));
    }
    return (_jsx(BenchmarkCard, { title: title, children: _jsx(DataTable, { data: data, columns: columns, className: 'table table-sm w-100 p-0', options: {
                info: false,
                paging: false,
                searching: false,
                language: { emptyTable: 'No data for this selection.' },
            }, children: _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { className: 'w-50 text-start' }), _jsx("th", { className: 'w-25 text-end', children: "NC days/visit - your fleet" }), _jsx("th", { className: 'w-25 text-end', children: "NC days/visit - industry total" })] }) }) }) }));
}
